module.exports = __webpack_public_path__ + "89b7a1ad73673099fa7dd688edba4233.png";